export const getHotSpotsConfig = ({
    customerType, customerId, startDate, endDate,
}) => ({
    url: '/api/dashboard/hotspot',
    method: 'GET',
    params: {
        [`${customerType}_id`]: customerId,
        start_date: startDate,
        end_date: endDate,
    },
});

export const deleteHotSpotConfig = ({
    hotSpotId,
}) => ({
    url: `/api/dashboard/hotspot/${hotSpotId}`,
    method: 'DELETE',
});

export const saveHotSpotConfig = ({
    hotSpot,
}) => ({
    url: '/api/dashboard/hotspot',
    method: 'POST',
    data: {
        ...hotSpot,
    },
});
